import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { ReportService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen } from "@/utils";

type QueryArgs = Parameters<typeof ReportService.getReachReport>[0];
type QueryFnData = AsyncReturnType<typeof ReportService.getReachReport>;
type Error = unknown;

const queryKey = (args: QueryArgs) => ["reports", "reach", args];

export const useReachReport = <TData = QueryFnData>(
  args: QueryArgs,
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const response = useQuery<QueryFnData, Error, TData>(
    queryKey(args),
    () => ReportService.getReachReport(args),
    {
      skeletonData: useConst({ report: gen.reports() }),
      ...options,
    }
  );

  return response;
};

useReachReport.queryKey = queryKey;
